<template>
  <Popover :placement="placement" :hoverable="!isMobile" :clickable="isMobile">
    <template #trigger>
      <slot name="trigger">
        <button class="flex size-5 cursor-default items-center justify-center rounded text-[--color-neutral-neutral-light] transition-colors  hover:text-[--color-neutral-neutral-lighter] focus:bg-[rgb(159,127,215,0.1)] focus-visible:outline focus-visible:outline-2 focus-visible:outline-blue-600">
          <Icon :name="triggerIcon" class="size-4" :class="triggerIconClass" />
        </button>
      </slot>
    </template>
    <template #panel="{ close }">
      <div
        class="max-w-64 rounded-md border border-[--v3-root-surface-border] bg-white p-4 shadow-lg will-change-transform"
      >
        <div class="flex flex-col gap-y-4">
          <div v-if="title" class="flex items-center gap-x-1">
            <Icon
              v-if="variant === 'warning'"
              class="size-4 text-[--v3-erank-carrot]"
              name="exclamation-triangle"
            />
            <h3
              class="v3-body-regular-400-line-height-1.5 !font-bold text-[--v3-global-textcolor]"
            >
              {{ title }}
            </h3>
          </div>
          <div class="v3-body-regular-400-line-height-1.5 text-[--v3-global-textcolor]">
            {{ content }}
          </div>
          <a
            v-if="link"
            :href="link.url"
            class="v3-body-regular-400-line-height-1.5 underline"
            target="_blank"
          >
            {{ link.label }}
          </a>
          <Button
            v-if="link && !hideButton"
            class="flex-row-reverse gap-x-2 self-start"
            label="Got it"
            @click="close"
          >
            <template #icon>
              <Icon class="size-4" name="check" />
            </template>
          </Button>
        </div>
      </div>
    </template>
  </Popover>
</template>

<script lang="ts" setup>
import type { Placement } from '@floating-ui/vue';
import Button from 'primevue/button';

import Icon from '@/common/components/atoms/Icon';
import Popover from '@/common/components/atoms/Popover';
import { useMobile }  from '@/common/composables/application';

interface Props {
  content: string
  link?: {
    label: string
    url: string
  }
  title?: string
  triggerIcon?: string
  placement?: Placement
  hideButton?: boolean
  variant?: 'info' | 'warning',
  triggerIconClass?: string
}

defineOptions({
  inheritAttrs: false,
});

withDefaults(defineProps<Props>(), {
  link: undefined,
  triggerIcon: 'info-circle',
  variant: 'info',
  placement: 'right-start',
  title: undefined,
  hideButton: false,
  triggerIconClass: '',
});

const { isMobile } = useMobile();
</script>
